import { parseAsInteger, parseAsString } from 'nuqs'

export const searchParams = {
	page: parseAsInteger.withDefault(1),
	limit: parseAsInteger.withDefault(10),
	q: parseAsString,
	gender: parseAsString,
	categories: parseAsString,
	selectedQuery: parseAsString,
}

export const dateSearchParams = {
	month: parseAsString.withDefault(''),
	year: parseAsString.withDefault(''),
}
